import {ChangeDetectorRef, Component, DoCheck, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { MasterSummaryAnswerModel, MasterSummaryPDModel, MasterSummaryQuestionModel, SurveyCutQuestionModel, SurveyVersionQuestionModel } from '../../../../models/survey/survey.model';
import { PercentageType } from '../../../constants/percentage.constants';
import {AbsolutePercentageModel} from '../../../../models/bar-chart/AbsolutePercentageModel'
import Utils from '../../../util/Util';
import { CommunicationService } from '../../../services/communication.service';
import { CHART_COLORS } from '../../../helpers/chart-helper';
@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.less']
})
export class BarChartComponent implements OnInit, OnChanges {

  @Input() title: string;
  @Input() subTitle = '';
  @Input() dataSource: any[];
  @Input() argumentField: string;
  @Input() valueField: string;
  @Input("surveyMasterSummaryPDModel") survMastSummPDModel: MasterSummaryPDModel;
  @Input("chartJ") chartJ: number;
  @Input("questionI") questionI: number;
  @Input("isCut") isCut: boolean;
  typePercentage: string
  questionShow: string;
  @Input() isCompareMode: boolean = false;
  isShowDialogPercentage:boolean = false;
  myArrayPercentagePopUp = Array<AbsolutePercentageModel>();
  @Input() isAllResponses: boolean;
  @Input() isSelectedAllResponses: boolean;
  surveyNameMaster: string;
  arrayPercentageHover = Array<AbsolutePercentageModel>();
  surveyNameMasterHover: string;
  @Input() isNizPitanja: boolean = false;
  @Input() question: MasterSummaryQuestionModel;
  echartsInstance: any;

  initOpts = {
    renderer: 'svg',
    width: 550,
    height: 0
  };

  chartOption: any;
  

  constructor(private communicationService: CommunicationService) {
  }

  ngOnInit() {
    this.communicationService.percentageDiff.subscribe((response) => {
      if(response.questionI === this.questionI) {
        this.reloadChart();
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['dataSource']) {
        this.reloadChart();
    }
  }

  reloadChart() {
    this.initChart();
    if (this.echartsInstance) {
        this.echartsInstance.resize({height: this.initOpts.height});
    }
  }

  customizeLabel = (arg: any) => {
    return {
      visible: true,
      backgroundColor: 'transparent',
      font: {
        color: 'black'
      },
      customizeText: function (e: any) {
        return e.value.toFixed(2) + '%';
      }
    };
  };

  customizeArgAxisLabel = (arg: any) => {
    let valueText = arg.valueText;
    let limitCharacter = 25;
    if (this.isHorizontal()) {
      limitCharacter = 45;
    }

    if (valueText.length > limitCharacter) {
      valueText = valueText.substring(0, limitCharacter - 3) + '...';
    } else if (this.isHorizontal()) {
      valueText = Array(limitCharacter - valueText.length).join(' ') + valueText;
    }
    return valueText;
  };

  customizeTooltip = (arg: any) => {
    const text = arg.originalArgument;
    return {
      text: text
    };
  };

  isHorizontal(): boolean {
    return this.dataSource.length > 2;
  }

  processClicEventBar(question: number){
    const _answerName = this.dataSource[question].answerName;
    const questionIndex = this.isAllResponses ? this.chartJ : this.questionI;
    const _answerList = this._getAnswerList(questionIndex)
    let _realAnswerIndex = -1
    for (const _el of _answerList) {
      _realAnswerIndex ++
      if(_el.answerName === _answerName){ break }
    }
    question = _realAnswerIndex;
    if(this.isCompareMode){
      if(this.survMastSummPDModel){
        let masterQuestion = this.obtainMasterChartObject(false);
        this.typePercentage = masterQuestion.typePercentageSelected;
        if(this.typePercentage){
          this.myArrayPercentagePopUp = this.calculatePercentages(question,false);
          this.showPercentageDialog();
        }
      }
    }
  }

  _getAnswerList(_questionIndex: number){
    if(this.survMastSummPDModel && this.survMastSummPDModel.listQuestionModel && this.isAllResponses){
      if(!this.isNizPitanja){
        return this.survMastSummPDModel.listQuestionModel[_questionIndex].listAnswerModel;
      }else{
        return this.survMastSummPDModel.listQuestionModel[_questionIndex].nizPitanja;
      }
    }else if(this.survMastSummPDModel && this.survMastSummPDModel.listSurveyVersionQuestion[0] && !this.isCut){
      if(!this.isNizPitanja){
        return this.survMastSummPDModel.listSurveyVersionQuestion[0].listQuestionModel[_questionIndex].listAnswerModel;
      }else{
        return this.survMastSummPDModel.listSurveyVersionQuestion[0].listQuestionModel[_questionIndex].nizPitanja;
      }
    }else if(this.survMastSummPDModel && this.survMastSummPDModel.listSurveyCutQuestion[0] && this.isCut){
      if(!this.isNizPitanja){
        return this.survMastSummPDModel.listSurveyCutQuestion[0].listQuestionModel[_questionIndex].listAnswerModel;
      }else{
        return this.survMastSummPDModel.listSurveyCutQuestion[0].listQuestionModel[_questionIndex].nizPitanja;
      }
    } else {
      return []
    }
  }

  getToolTipText(question: number): boolean{
    if(this.isCompareMode && this.survMastSummPDModel != undefined && this.survMastSummPDModel[question]){
        let masterQuestion = this.obtainMasterChartObject(true);
        this.typePercentage = masterQuestion.typePercentageSelected;
        if(this.typePercentage){
            this.arrayPercentageHover = this.calculatePercentages(question,true);
            if(this.arrayPercentageHover && this.arrayPercentageHover.length > 0){
                return false;
            }
        }
    }
    return false;
  }

  private calculatePercentages(question: number,isHover: boolean): Array<AbsolutePercentageModel>{
    let masterResponse = this.obtainMasterChartAnswerObject(question);
    if(!isHover){
      this.questionShow = masterResponse.answerName;
    }
    let listCut = [];
    let listNoCut = [];
    let listAllResponses = [];
    let questionIndex = this.isAllResponses ? this.chartJ : this.questionI;
    let result: Array<AbsolutePercentageModel> = [];
    if(this.survMastSummPDModel.listSurveyVersionQuestion){
      if(PercentageType.ABSOLUTE == this.typePercentage){
        listNoCut = this.calculateAllAbsolute(masterResponse,question,this.survMastSummPDModel.listSurveyVersionQuestion,questionIndex,false);
      }else if(PercentageType.RELATIVE == this.typePercentage){
        listNoCut = this.calculateAllRelative(masterResponse,question,this.survMastSummPDModel.listSurveyVersionQuestion,questionIndex,false);
      }
    }
    if(this.survMastSummPDModel.listSurveyCutQuestion){
      if(PercentageType.ABSOLUTE == this.typePercentage){
        listCut = this.calculateAllAbsolute(masterResponse,question,this.survMastSummPDModel.listSurveyCutQuestion,questionIndex,true);
      }else if(PercentageType.RELATIVE == this.typePercentage){
        listCut = this.calculateAllRelative(masterResponse,question,this.survMastSummPDModel.listSurveyCutQuestion,questionIndex,true);
      }
    }
    if(this.survMastSummPDModel.listQuestionModel && !this.isAllResponses){
      listAllResponses = this.calculateAllResponses(masterResponse,this.survMastSummPDModel.listQuestionModel,questionIndex,question,this.typePercentage);
    }
    if(this.isSelectedAllResponses){
      result = [ ...listAllResponses, ...listNoCut, ...listCut];
    }else{
      result = [ ...listNoCut, ...listCut];
    }
    return result;
  }

  //This function return the chose chart based on the input parameters chartJ and questionI and if isCutQuestion or not
  private obtainMasterChartAnswerObject(question: number): MasterSummaryAnswerModel{
    if(this.isAllResponses){
      if(!this.isNizPitanja){
        return this.survMastSummPDModel.listQuestionModel[this.chartJ].listAnswerModel[question];
      }else{
        return this.survMastSummPDModel.listQuestionModel[this.chartJ].nizPitanja[question];
      }
    }else{
      if(!this.isCut){
        if(!this.isNizPitanja){
          return this.survMastSummPDModel.listSurveyVersionQuestion[this.chartJ].listQuestionModel[this.questionI].listAnswerModel[question];
        }else{
          return this.survMastSummPDModel.listSurveyVersionQuestion[this.chartJ].listQuestionModel[this.questionI].nizPitanja[question];
        }
      }else{
        if(!this.isNizPitanja){
          return this.survMastSummPDModel.listSurveyCutQuestion[this.chartJ].listQuestionModel[this.questionI].listAnswerModel[question];
        }else{
          return this.survMastSummPDModel.listSurveyCutQuestion[this.chartJ].listQuestionModel[this.questionI].nizPitanja[question];
        }
      }
    }
  }

  private obtainMasterChartObject(isHover:boolean): MasterSummaryQuestionModel{
    if(this.isAllResponses){
      if(!isHover){
        this.surveyNameMaster = 'All responses';
      }else{
        this.surveyNameMasterHover = 'All responses';
      }
      return this.survMastSummPDModel.listQuestionModel[this.chartJ];
    }else{
      if(!this.isCut){
        if(!isHover){
          this.surveyNameMaster = this.survMastSummPDModel.listSurveyVersionQuestion[this.chartJ].surveyName;
        }else{
          this.surveyNameMasterHover = this.survMastSummPDModel.listSurveyVersionQuestion[this.chartJ].surveyName;
        }
        return this.survMastSummPDModel.listSurveyVersionQuestion[this.chartJ].listQuestionModel[this.questionI];
      }else{
        if(!isHover){
          this.surveyNameMaster = this.survMastSummPDModel.listSurveyCutQuestion[this.chartJ].surveyName;
        }else{
          this.surveyNameMasterHover = this.survMastSummPDModel.listSurveyCutQuestion[this.chartJ].surveyName;
        }
        return this.survMastSummPDModel.listSurveyCutQuestion[this.chartJ].listQuestionModel[this.questionI];
      }
    }
  }

  //This function will iterate over all chart and it will call the function to calculate the absolute percentage difference
  private calculateAllAbsolute(masterResponse: MasterSummaryAnswerModel,responseNumber: number,listQuestion: SurveyVersionQuestionModel[] | SurveyCutQuestionModel[],questionIndex: number,isCutList:boolean){
    let i: number;
    let result = [];
    for(i=0;i<listQuestion.length;i++){
      if(this.isAllResponses){
        let percentage = 0;
        if(!this.isNizPitanja){
          percentage = this.calculateAbsolute(masterResponse,listQuestion[i].listQuestionModel[questionIndex].listAnswerModel[responseNumber]);
        }else{
          percentage = this.calculateAbsolute(masterResponse,listQuestion[i].listQuestionModel[questionIndex].nizPitanja[responseNumber]);
        }
        result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
      }else{
        if(i != this.chartJ){
          let percentage = 0;
          if(!this.isNizPitanja){
            percentage = this.calculateAbsolute(masterResponse,listQuestion[i].listQuestionModel[questionIndex].listAnswerModel[responseNumber]);
          }else{
            percentage = this.calculateAbsolute(masterResponse,listQuestion[i].listQuestionModel[questionIndex].nizPitanja[responseNumber]);
          }
          result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
        }else{
          if(i == this.chartJ && isCutList && !this.isCut){
            let percentage = 0;
            if(!this.isNizPitanja){
              percentage = this.calculateAbsolute(masterResponse,listQuestion[i].listQuestionModel[questionIndex].listAnswerModel[responseNumber]);
            }else{
              percentage = this.calculateAbsolute(masterResponse,listQuestion[i].listQuestionModel[questionIndex].nizPitanja[responseNumber]);
            }
            result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
          }else if(i == this.chartJ && !isCutList && this.isCut){
            let percentage = 0;
            if(!this.isNizPitanja){
              percentage = this.calculateAbsolute(masterResponse,listQuestion[i].listQuestionModel[questionIndex].listAnswerModel[responseNumber]);
            }else{
              percentage = this.calculateAbsolute(masterResponse,listQuestion[i].listQuestionModel[questionIndex].nizPitanja[responseNumber]);
            }
            result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
          }
        }
      }
    }
    return result;
  }

  //This function will apply this formula PercentageMaster - PercentageSibling to the sibling response sent as parameter
  private calculateAbsolute(masterResponse: MasterSummaryAnswerModel,siblingResponse: MasterSummaryAnswerModel): number{
    if(masterResponse && siblingResponse){
        let diffPercentage = masterResponse.answerPercentage - siblingResponse.answerPercentage;
        return Utils.roundNumber(diffPercentage,1);
    }
    return 0;
  }

  //This function will iterate over all chart and it will call the function to calculate the relative percentage difference
  private calculateAllRelative(masterResponse: MasterSummaryAnswerModel,responseNumber: number,listQuestion: SurveyVersionQuestionModel[] | SurveyCutQuestionModel[],questionIndex: number,isCutList:boolean){
    let i: number;
    let result = [];
    for(i=0;i<listQuestion.length;i++){
      if(this.isAllResponses){
        let percentage = 0;
        if(!this.isNizPitanja){
          percentage = this.calculateRelative(masterResponse,listQuestion[i].listQuestionModel[questionIndex].listAnswerModel[responseNumber]);
        }else{
          percentage = this.calculateRelative(masterResponse,listQuestion[i].listQuestionModel[questionIndex].nizPitanja[responseNumber]);
        }
        if(!isNaN(percentage)){
          result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
        }
      }else{
        if(i != this.chartJ){
          let percentage = 0;
          if(!this.isNizPitanja){
            percentage = this.calculateRelative(masterResponse,listQuestion[i].listQuestionModel[questionIndex].listAnswerModel[responseNumber]);
          }else{
            percentage = this.calculateRelative(masterResponse,listQuestion[i].listQuestionModel[questionIndex].nizPitanja[responseNumber]);
          }
          if(!isNaN(percentage)){
            result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
          }
        }else{
          if(i == this.chartJ && isCutList && !this.isCut){
            let percentage = 0;
            if(!this.isNizPitanja){
              percentage = this.calculateRelative(masterResponse,listQuestion[i].listQuestionModel[questionIndex].listAnswerModel[responseNumber]);
            }else{
              percentage = this.calculateRelative(masterResponse,listQuestion[i].listQuestionModel[questionIndex].nizPitanja[responseNumber]);
            }
            if(!isNaN(percentage)){
              result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
            }
          }else if(i == this.chartJ && !isCutList && this.isCut){
            let percentage = 0;
            if(!this.isNizPitanja){
              percentage = this.calculateRelative(masterResponse,listQuestion[i].listQuestionModel[questionIndex].listAnswerModel[responseNumber]);
            }else{
              percentage = this.calculateRelative(masterResponse,listQuestion[i].listQuestionModel[questionIndex].nizPitanja[responseNumber]);
            }
            if(!isNaN(percentage)){
              result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
            }
          }
        }
      }
    }
    return result;
  }

  //This function will apply this formula ((PercentageMaster - PercentageSibling)/PercentageSibling)*100 to the sibling response sent as parameter
  private calculateRelative(masterResponse: MasterSummaryAnswerModel,siblingResponse: MasterSummaryAnswerModel): number{
    if(masterResponse && siblingResponse){
        let diffPercentage = 0.0;
        let numerator = masterResponse.answerPercentage - siblingResponse.answerPercentage;
        if(siblingResponse.answerPercentage != 0){
          diffPercentage = (numerator/siblingResponse.answerPercentage)*100;
        }else if(siblingResponse.answerPercentage == 0 && numerator != 0){
          return NaN;
        }
        return Utils.roundNumber(diffPercentage,1);
    }
    return 0;
  }

  private calculateAllResponses(masterResponse: MasterSummaryAnswerModel,listQuestions:MasterSummaryQuestionModel[],questionIndex:number,responseNumber:number,percentageType:string){
    let result = [];
    if(PercentageType.ABSOLUTE == percentageType){
      let percentage = 0;
      if(!this.isNizPitanja){
        percentage = this.calculateAbsolute(masterResponse,listQuestions[questionIndex].listAnswerModel[responseNumber]);
      }else{
        percentage = this.calculateAbsolute(masterResponse,listQuestions[questionIndex].nizPitanja[responseNumber]);
      }
      result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),'All responses'));
    }else if(PercentageType.RELATIVE == percentageType){
      let percentage = 0;
      if(!this.isNizPitanja){
        percentage = this.calculateRelative(masterResponse,listQuestions[questionIndex].listAnswerModel[responseNumber]);
      }else{
        percentage = this.calculateRelative(masterResponse,listQuestions[questionIndex].nizPitanja[responseNumber]);
      }
      if(!isNaN(percentage)){
        result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),'All responses'));
      }
    }
    return result;
  }

  //This function will return Lower if the parameter is lower than 0 or Greater or equal in other cases
  private getDescriptionByPercentage(percentage: number): string{
    let result = "the same as";
    if(percentage > 0){
      result = "higher"
    }else if(percentage < 0){
      result = "lower";
    }
    return result;
  }

  private showPercentageDialog(){
    this.isShowDialogPercentage = true;
  }

  hidePercentageDialog() {
    this.isShowDialogPercentage = false;
  }

  private createObject(id:number,percentage:number,percDesc:string,survName:string): AbsolutePercentageModel{
    return {
      id: id,
      diffPercentage: Math.abs(percentage),
      percDesc: percDesc,
      survName: survName
    };
  }

  getResponseLabel(item) {
    if (this.question.answerType === 'QuestionBundle') {
        return '#' + item.questionNumber;
    }
    const answerCount = item.answerCount != null ? item.answerCount : item.answeredCount
    const answerCountAdjust = answerCount >= 0 ? answerCount : 0
    const response = `${answerCountAdjust}`
    return response
  }

  getAnswerPercentage(item, answerType, scaleMax){
    if (answerType === 'QuestionBundle') {
        return (item.answerPercentage && item.answerPercentage > 0 ) ? item.answerPercentage / scaleMax * 100 : 0
    }
    return (item.answerPercentage && item.answerPercentage > 0 ) ? item.answerPercentage : 0
  }

  onChartClick(e) {
    this.processClicEventBar(e.dataIndex);
  }

  onChartInit(ec) {
    this.echartsInstance = ec;
  }

  private initChart() {
    let dataSeries = [];
    let responseData = [];
    let answerPercentageData = [];
    let diffPercentageData = [];
    let chartHeight = 0;
    const barHeight = 40;
    let colorIndex = 0;
    if (this.dataSource && this.dataSource.length) {
      this.dataSource.forEach(item => {
        dataSeries.push({
          value: this.getAnswerPercentage(item, this.question.answerType, this.question.scaleMax),
          name: item.answerName,
          itemStyle: {color: CHART_COLORS[colorIndex]},
          label: {
              width: 380,
              overflow: 'truncate',
              ellipsis: '...'
          }
        });

        colorIndex++;
        if (colorIndex === 10) {
            colorIndex = 0;
        }

        answerPercentageData.push(Number(item.answerPercentage).toFixed(1) + (this.question.answerType === 'QuestionBundle' ? '' : '%'));
        responseData.push(this.getResponseLabel(item));
        diffPercentageData.push(item.answerDiffPercentage)
      });
      chartHeight = this.dataSource.length * (barHeight + 10);
      this.initOpts.height = chartHeight + 60;
    }

    this.chartOption = {
      animation: false,
      height: chartHeight,
      tooltip: {
        useHTML: true,
        trigger: "axis",
        borderRadius: 0,
        borderColor: '#5E5E5E',
        shadowColor: null,
        axisPointer: {
            type: "shadow",
            animation: false
        },
        formatter: (params) => {
            return "<div style='max-width: 418px; white-space:normal;'>" + params[0].data.name + "</div>";
        },
        position: function (point, params, dom, rect, size) {
            return {top: point[1] + 10, left: 55};
        }
      },
      grid: {
        top: 40,
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          show: false
        },
        splitLine: {
          show: false
        },
        max: 100
      },
      yAxis: [
      {
        type: 'category',
        data: responseData,
        position: 'left',
        inverse: true,
        axisLabel: {
          formatter: '{value}',
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        }
      },
      {
        type: 'category',
        data: answerPercentageData,
        align: 'right',
        zlevel: 100,
        inverse: true,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          inside: true,
          formatter: '{value}',
          color: function(value, index) {
            return '#333';
          }
        }
      },
      {
        type: 'category',
        data: diffPercentageData,
        align: 'right',
        inverse: true,
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          formatter: function(value) {
            if (!isNaN(value)) {
              if (Number(value) === 0) {
                return '';
              } else if (value > 0) {
                return value + '% ' + '↑';
              } else {
                return -value + '% ' + '↓';
              }
            }
            return '';
          },
          color: function(value, index) {
            if (!isNaN(value)) {
              if (value === 0) {
                return 'black';
              } else if (value > 0) {
                return '#04AA6D';
              } else {
                return '#FF0000';
              }
            }
          }
        },
      }
    ],
    series: [
    {
      barWidth: barHeight + 'px',
      barGap: 0,
      showBackground: 'true',
      label: {
        show: true,
        position: 'left',
        align: 'left',
        distance: -20,
        textBorderWidth: '0',
        formatter: function (params) {
          return params.name;
        }
      },
      data: dataSeries,
      type: 'bar'
    }]
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/chart/bar-chart/bar-chart.component.ts